<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20"/>
    <path class="call_fill_hoverEffect" d="M29.4087 17.5542V24.4355C29.4087 30.3394 21.5914 30.3394 21.5914 24.4355V17.5542C21.5914 11.4819 29.4087 11.4819 29.4087 17.5542ZM26.4707 34.1725V36.0218C26.4592 36.2853 26.3519 36.534 26.1711 36.7162C25.9903 36.8984 25.75 37 25.5 37C25.2501 37 25.0097 36.8984 24.8289 36.7162C24.6482 36.534 24.5409 36.2853 24.5293 36.0218V34.1616C23.6362 34.0525 22.7654 33.7934 21.9498 33.3941C21.0385 32.9468 20.2083 32.3348 19.4967 31.5858L19.4863 31.5661C18.701 30.7369 18.076 29.7543 17.6465 28.6732C17.2185 27.5866 16.9988 26.4213 17 25.2445C16.9985 25.0412 17.0546 24.842 17.1611 24.6725C17.2676 24.5029 17.4196 24.3709 17.5977 24.2931C17.7757 24.2153 17.9717 24.1955 18.1606 24.236C18.3494 24.2766 18.5225 24.3757 18.6576 24.5208L18.6783 24.5426C18.8475 24.7327 18.9416 24.9837 18.9414 25.2445C18.9401 26.1496 19.1092 27.046 19.4387 27.8816C20.1117 29.5844 21.3948 30.9376 23.0085 31.647C23.8007 31.9948 24.6503 32.1739 25.5083 32.1739C26.3663 32.1739 27.2159 31.9948 28.0081 31.647C28.8053 31.296 29.5297 30.7834 30.14 30.1382L30.1566 30.1229C30.76 29.4813 31.2398 28.7224 31.5697 27.8882C31.8971 27.0499 32.0633 26.1513 32.0586 25.2445C32.0702 24.981 32.1775 24.7324 32.3582 24.5502C32.539 24.368 32.7794 24.2664 33.0293 24.2664C33.2793 24.2664 33.5196 24.368 33.7004 24.5502C33.8811 24.7324 33.9885 24.981 34 25.2445C34.0009 26.4191 33.7812 27.5822 33.3536 28.6666C32.9231 29.7577 32.2945 30.7493 31.5034 31.5858L31.4847 31.6032C30.778 32.3444 29.9541 32.9497 29.0502 33.3919C28.2338 33.7909 27.3623 34.05 26.4686 34.1594L26.4707 34.1725Z" fill="#80B7FF"/>
    <path d="M13 13L37 37" stroke="#EB5757" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallStopAudio"
}
</script>

<style scoped>
rect{
    fill: var(--backgroundColor);
}
</style>
